<template>
  <div>
    <div class="mt-3 text_s" style="margin-top: 30px">
      <div class="color3 pl-3 font-w font-16">无牌车入场成功</div>
      <div class="color9 pl-3 font-13 font-w mt-3" v-if="entryTime">
        入场时间：{{ entryTime }}
      </div>
      <div class="" style="margin-top: 18px">
        <van-divider />
      </div>

      <div class="color3 pl-3 font-w font-18 mt-5">您本次的停车车牌号为：</div>

      <div
        class="flex mt-4"
        style="
          background-color: #f1fcf5;
          width: 90%;
          height: 160px;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin: 20px auto;
        "
      >
        <div class="font-w" style="color: #2ea639; font-size: 32px">
          {{ CarNumber }}
        </div>
        <div v-if="hintMsg" class="px-2 font-13 font-w" style="">
          {{ hintMsg }}
        </div>
        <div
          v-else
          class="px-2 font-13 font-w"
          style="margin-top: 20px; padding: 0 10px"
        >
          请截图或采取其他方式记录该车牌,备出场时使用！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nullPlateEntry, getWxUserLoginH5, getAliUserLoginH5 } from '@/api/h5.js'
import { Toast } from 'vant';
export default {
  props: {

  },
  data () {
    return {
      entryTime: '2025-07-09 10:12:47',
      CarNumber: '',
      hintMsg: '',

      //  重定向获取的code信息
      code: '',
      authCode: '',
    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created () {
    //获取当前url   取到code 
    var url = window.location.href;
    var params = this.parse_url(url);
    this.parkId = params.parkId
    this.areaId = params.areaId
    this.aisleId = params.aisleId
    this.laneId = params.laneId
    this.code = params.code
    // this.initOrderInfo()

    if (params.source == 'alipay_wallet') {
      this.authCode = params.auth_code
      this.initALiOrderInfo()
    } else {
      this.code = params.code
      this.initOrderInfo()
    }
  },
  mounted () {

  },
  methods: {
    //转码
    parse_url (url) { //定义函数
      var pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      var parames = {}; //定义数组
      url.replace(pattern, function (a, b, c) {
        parames[b] = c;
      });
      return parames; //返回这个数组.
    },
    // 支付宝初始化获取信息
    async initALiOrderInfo () {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getAliUserLoginH5({
        // 动态获取
        authCode: this.authCode,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        const res = data.data
        if (res.token) {
          this.getNullPlateInfo(res.token)
        } else {
          Toast(data.msg)
        }

      } else {
        Toast(data.msg)
      }
    },
    // 初始化获取信息
    async initOrderInfo () {
      /*
          获取链接code
          获取车牌号
          获取车场id
          获取区域id
      */
      const { data } = await getWxUserLoginH5({
        // 动态获取
        code: this.code,
        parkId: this.parkId,
      })
      if (data.code == 200) {
        const res = data.data
        if (res.token) {
          this.getNullPlateInfo(res.token)
        } else {
          Toast(data.msg)
        }
      } else {
        Toast(data.msg)
      }
    },
    async getNullPlateInfo (token) {
      const { data } = await nullPlateEntry({
        parkId: this.parkId,
        areaId: this.areaId,
        aisleId: this.aisleId,
        laneId: this.laneId,
        token
      })
      if (data.code == 200) {
        this.CarNumber = data.data.carNo
        this.entryTime = data.data.enterTime
      } else {
        Toast(data.msg)
      }
    }
  },
};
</script>

<style scoped lang="less">
.pl-3 {
  padding-left: 30px;
}
.text_s {
  text-align: start;
}
.flex {
  display: flex;
}
.color3 {
  color: #333;
}
.color9 {
  color: #999;
}
.font-18 {
  font-size: 22px;
}
.font-16 {
  font-size: 20px;
}
.font-13 {
  font-size: 14px;
}
.font-w {
  font-weight: bold;
}
.mt-3 {
  margin-top: 15px;
}
.mt-5 {
  margin-top: 25px;
}
</style>
